import { useContext } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { pipe, pathOr, sort, descend, prop, propEq, find } from 'ramda'
import { select } from '@/store'
import { colors } from '@/styles'
import useIsMobile from '@/hooks/use-is-mobile'
import DocumentSettingsIcon from './document-settings-icon.svg'
import DocumentPageComponent from './document-page-component'
import Context from '../context'

const DocumentSettings = styled.div`
  background-color: ${colors.white};
  width: 100%;
  ${props => (props.isMobile ? 'max-width: 100%;' : 'max-width: 240px;')}

  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`

const TitleWrapper = styled.div`
  display: flex;

  margin: 12px 0;
`

const Title = styled.h5`
  font-size: 16px;
  font-weight: 700;
  margin-left: 8px;
  max-width: 70%;
`

const DocumentPageWidget = ({
  selectedPage,
  urls,
  stageRef,
  updateSelectedPage,
  zoomLevel,
  handleClick,
  currentPage,
  currentDocument,
  signees,
  contractId,
  isEdit = false,
  handleCanvasPageEvent,
  loadNewUrlImage,
  isCreateContract
}) => {
  const userContext = useContext(Context)
  const { packageFiles = [] } = useSelector(state =>
    select.contract.contractPackageInfo(state, { contractId })
  )

  const { t } = useTranslation()

  const { items, fileMetadata, setFileMetadata } = userContext
  const currentItems = pathOr([], [currentDocument], items)
  const currentFile = find(propEq('id', currentDocument), packageFiles)
  const isMobile = useIsMobile()
  const formattedFiles = pipe(sort(descend(prop('document_type'))))(packageFiles)

  return (
    <DocumentSettings isMobile={isMobile}>
      <TitleWrapper>
        <img src={DocumentSettingsIcon} alt="icon" />
        <Title>{t('l.contract_edit.document_widget.document_settings.title', 'Documents')}</Title>
      </TitleWrapper>
      {isEdit ? (
        <DocumentPageComponent
          key={currentFile?.id}
          isCurrent={true}
          file={currentFile}
          stageRef={stageRef}
          selectedPage={selectedPage}
          updateSelectedPage={updateSelectedPage}
          urls={urls}
          currentPage={currentPage}
          handleClick={handleClick}
          zoomLevel={zoomLevel}
          hideBorder={true}
          fileMetadata={fileMetadata}
          setFileMetadata={setFileMetadata}
          currentItems={currentItems}
          signees={signees}
          isEdit={isEdit}
          handleCanvasPageEvent={handleCanvasPageEvent}
          isCreateContract={isCreateContract}
        />
      ) : (
        formattedFiles.map((file, index) => {
          const isCurrent = currentDocument === file?.id
          return (
            <DocumentPageComponent
              key={index}
              isCurrent={isCurrent}
              file={file}
              stageRef={stageRef}
              selectedPage={selectedPage}
              updateSelectedPage={updateSelectedPage}
              urls={urls}
              currentPage={currentPage}
              handleClick={handleClick}
              zoomLevel={zoomLevel}
              hideBorder={index === 0}
              fileMetadata={fileMetadata}
              setFileMetadata={setFileMetadata}
              currentItems={currentItems}
              signees={signees}
              isEdit={isEdit}
              handleCanvasPageEvent={handleCanvasPageEvent}
              loadNewUrlImage={loadNewUrlImage}
              isCreateContract={isCreateContract}
            />
          )
        })
      )}
    </DocumentSettings>
  )
}

export default DocumentPageWidget
